import { render, staticRenderFns } from "./StatisticsCompany.vue?vue&type=template&id=12050052"
import script from "./StatisticsCompany.vue?vue&type=script&lang=js"
export * from "./StatisticsCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports